import axios from "axios";
import Requests from "../constants/requests.json";
const URL = process.env.REACT_APP_API_URL;
const URL2 = process.env.REACT_APP_USER_API_URL;
const App_Version = process.env.REACT_APP_VERSION;
// const token = localStorage.getItem('token');
// const parseQueryParams = (params = {}) => {
//   if (!Object.entries(params).length) return "";
//   return Object.entries(params).reduce(
//     (acc, [key, value]) => acc + `${key}=${value}&`,
//     "?"
//   );
// };

const Api = {
  userLogin({ phoneNumber }) {
    return axios.post(URL + Requests.LOGIN, {
      mobile: phoneNumber,
    });
  },
  verifyOtp({ otp, phoneNumber }) {
    return axios.post(URL + Requests.OTP, {
      mobile: phoneNumber,
      otp: otp,
    });
  },
  addStage(stageName, stageDescription, startDate, endDate, userToken) {
    return axios.post(
      URL + Requests.SCHEDULE_STAGE,
      {
        name: stageName,
        description: stageDescription,
        startAt: startDate,
        endAt: endDate,
      },
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },
  getStages(userToken) {
    return axios.get(URL + Requests.SCHEDULE_STAGE, {
      headers: {
        Authorization: `Bearer ${userToken}`,
        App_Version: App_Version,
        Platform: "web",
      },
    });
  },
  // getSingleState(id) {
  //   return axios.get(URL + `${Requests.SCHEDULE_STAGE}/${id}`, {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     }
  //   });
  // },
  editState(
    selectedId,
    stageName,
    stageDescription,
    startDate,
    endDate,
    userToken
  ) {
    return axios.patch(
      URL + `${Requests.SCHEDULE_STAGE}/${selectedId}`,
      {
        name: stageName,
        description: stageDescription,
        startAt: startDate,
        endAt: endDate,
      },
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },
  // getCommisionList() {
  //   return axios.get(URL + Requests.COMMISSION, {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     }
  //   });
  // },
  getNominations(userToken) {
    return axios.get(URL + Requests.NOMINATIONS + "?page=1&size=10000", {
      headers: {
        Authorization: `Bearer ${userToken}`,
        App_Version: App_Version,
        Platform: "web",
      },
    });
  },
  getMultipleNominations(userToken) {
    return axios.get(
      URL + Requests.MULTIPLE_NOMINATIONS + "?page=1&size=10000",
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },
  rejectMultipleNominations(userToken, memberId, remarks) {
    return axios.post(
      URL + Requests.REJECT_MULTIPLE_NOMINATIONS,
      {
        memberId: memberId,
        remarks: remarks,
      },
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },
  getNominationDetails(nominationId, userToken) {
    return axios.get(URL + `${Requests.NOMINATIONS}/${nominationId}`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
        App_Version: App_Version,
        Platform: "web",
      },
    });
  },
  getNominationDetailLogs(nominationId, userToken) {
    return axios.get(
      URL +
        `${Requests.NOMINATIONDTLLOGS}/${nominationId}` +
        "?page=1&size=10000",
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },
  setNominationStatus(nominationId, status, note, userToken) {
    return axios.patch(
      URL + `${Requests.NOMINATIONS}/${nominationId}`,
      {
        status: status,
        remarks: note,
      },
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },
  getAssociationPosition(userToken) {
    return axios.get(
      URL + Requests.ASSOCIATION_POSITION + "?page=1&size=10000",
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },
  getZoneList(userToken) {
    return axios.get(URL + Requests.ZONES + "?page=1&size=10000", {
      headers: {
        Authorization: `Bearer ${userToken}`,
        App_Version: App_Version,
        Platform: "web",
      },
    });
  },
  getNotifications(userToken) {
    return axios.get(URL + Requests.NOTIFICATIONS + "?page=1&size=10000", {
      headers: {
        Authorization: `Bearer ${userToken}`,
        App_Version: App_Version,
        Platform: "web",
      },
    });
  },
  updateNotifications(
    notificationTitle,
    description,
    targetZone,
    scheduleDate,
    status,
    selectedId,
    userToken
  ) {
    return axios.patch(
      URL + Requests.NOTIFICATIONS + "/" + selectedId,
      {
        title: notificationTitle,
        message: description,
        targetZone: targetZone,
        scheduledAt: scheduleDate,
        status: status,
      },
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },
  deleteNotifications(selectedId, userToken) {
    return axios.delete(URL + Requests.NOTIFICATIONS + "/" + selectedId, {
      headers: {
        Authorization: `Bearer ${userToken}`,
        App_Version: App_Version,
        Platform: "web",
      },
    });
  },
  getSettings(userToken) {
    return axios.get(URL + Requests.SETTINGS, {
      headers: {
        Authorization: `Bearer ${userToken}`,
        App_Version: App_Version,
        Platform: "web",
      },
    });
  },
  updateSettings(id, isEnabled, userToken) {
    return axios.patch(
      URL + `${Requests.SETTINGS}/${id}`,
      {
        isEnabled,
      },
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },
  saveAssociationPosition(
    name,
    totalPositions,
    targetNomineeZone,
    targetVotersZone,
    gender,
    userToken
  ) {
    return axios.post(
      URL + `${Requests.ASSOCIATION_POSITION}`,
      {
        name: name,
        totalPositions: totalPositions,
        targetNomineeZone: targetNomineeZone,
        targetVotersZone: targetVotersZone,
        gender: gender,
      },
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },
  updateAssociationPosition(
    associationId,
    name,
    totalPositions,
    targetNomineeZone,
    targetVotersZone,
    gender,
    userToken
  ) {
    return axios.patch(
      URL + `${Requests.ASSOCIATION_POSITION}/${associationId}`,
      {
        name: name,
        totalPositions: totalPositions,
        targetNomineeZone: targetNomineeZone,
        targetVotersZone: targetVotersZone,
        gender: gender,
      },
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },
  deleteAssociationPosition(associationId, userToken) {
    return axios.delete(
      URL + `${Requests.ASSOCIATION_POSITION}/${associationId}`,
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },
  getResult(userToken) {
    return axios.get(URL + `${Requests.RESULT}`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
        App_Version: App_Version,
        Platform: "web",
      },
    });
  },
  setResultVerified(positionId, nominationId, userToken) {
    return axios.post(
      URL + `${Requests.RESULT_VERIFY}`,
      {
        positionId: positionId,
        nominationId: nominationId,
      },
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },
  postPublishResult(positionId, userToken) {
    return axios.post(
      URL + `${Requests.RESULT_PUBLISH}`,
      {
        positionId: positionId,
      },
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },
  getElectionToken(phoneNumber) {
    try {
      return axios.post(
        URL2 + Requests.ELECTIONTOKEN,
        {
          mobile: `${phoneNumber}`,
        },
        {
          headers: {
            "is-election-commission": "TRUE",
            App_Version: App_Version,
            Platform: "web",
          },
        }
      );
    } catch {}
  },
  getMemberDetails(pfNumber, token) {
    return axios.get(URL2 + `${Requests.MEMBERDETAILS}/` + pfNumber, {
      headers: {
        "election-token": token,
        App_Version: App_Version,
        Platform: "web",
      },
    });
  },
  putMemberDetails(pfNumber, token, mobile, zone, email) {
    return axios.put(
      URL2 + `${Requests.MEMBERDETAILS}/` + pfNumber,
      {
        mobile: mobile,
        zone: zone,
        email: email,
      },
      {
        headers: {
          "election-token": token,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },
  getElectionZone(token) {
    return axios.get(URL2 + `${Requests.ELECTIONZONE}`, {
      headers: {
        "election-token": token,
        App_Version: App_Version,
        Platform: "web",
      },
    });
  },
  getResultStartButtonStatus(userToken) {
    return axios.get(URL + `${Requests.CHECK_START_RESULT_STATUS}`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
        App_Version: App_Version,
        Platform: "web",
      },
    });
  },

  startResultCalculation(userToken) {
    return axios.post(
      URL + `${Requests.START_RESULT_COUNTING}`,
      {
        confirm: true,
      },
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },

  getStatsData(userToken) {
    return axios.get(URL + `${Requests.GET_STATS_DATA}`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
        App_Version: App_Version,
        Platform: "web",
      },
    });
  },
  getZoneWiseStatsData(userToken) {
    console.log("return response api", URL2);
    return axios.get(URL2 + `${Requests.GET_ZONEWISE_STATS_DATA}`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
        App_Version: App_Version,
        Platform: "web",
      },
    });
  },

  sedMessage(token, message) {
    return axios.post(
      URL2 + `${Requests.SMS}`,
      {
        message_content: message,
      },
      {
        headers: {
          "election-token": token,
          App_Version: App_Version,
          Platform: "web",
        },
      }
    );
  },

  sendSmsReminderMemberNotVoted(value) {
    const encode = encodeURIComponent(value);
    return axios.post(URL2 + `${Requests.SMS_REMINDER}?message=${encode}`, {
      headers: {
        App_Version: App_Version,
        Platform: "web",
      },
    });
  },
};
export default Api;
